import { 
  FETCH_IMAGES_SUCCESS, 
  FETCH_IMAGES_FAILED,
  APPROVE_IMAGES_SUCCESS,
  APPROVE_IMAGES_FAILED,
  REJECT_IMAGE_SUCCESS,
  REJECT_IMAGE_FAILED,
  UPDATE_MAILCHIMP_SUCCESS,
  UPDATE_MAILCHIMP_FAILED,
  FETCH_MAILCHIMP_MEMBER_SUCCESS,
  FETCH_MAILCHIMP_MEMBER_FAILED  
} from "../actions/types";

import _ from "lodash";

export default function(state = { 
    status: null,
    approvedStatus: null,
    rejectStatus: null 
  }, action) {
  switch (action.type) {
    case FETCH_IMAGES_SUCCESS:
      return {
        ...state,
        status: "success",
        data: _.map(action.payload.data)
      };
    case FETCH_IMAGES_FAILED:
      return { ...state, status: "failed" };
    case APPROVE_IMAGES_SUCCESS:
      return { ...state, approvedStatus: "success"};
    case APPROVE_IMAGES_FAILED:
      return { ...state, approvedStatus: "failed" };
    case REJECT_IMAGE_SUCCESS:
      return { ...state, rejectStatus: "success"};
    case REJECT_IMAGE_FAILED:
      return { ...state, rejectStatus: "failed" };
    case UPDATE_MAILCHIMP_SUCCESS:
      return { ...state, mcUpdateStatus: "success" };
    case UPDATE_MAILCHIMP_FAILED:
      return { ...state, mcUpdateStatus: "failed" };
    case FETCH_MAILCHIMP_MEMBER_SUCCESS:
      return { ...state, 
        mcFetchStatus: "success",
        mcdata: _.map(action.payload.data)
      };
    case FETCH_MAILCHIMP_MEMBER_FAILED:
      return { ...state, mcFetchStatus: "failed" };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/imagesReducer.js